const common = {
  "account.error.generic": "Something went wrong while loading your account.",
  "account.error.reload": "Something went wrong while loading your account. Please click the refresh button to try again.",
};

const recovery = {
  "account.recovery.user.title": "We need to recover your profile",
  "account.recovery.user.message": "Your BeYourBest profile record is missing. Recover it now to keep using your account normally.",
  "account.recovery.user.action": "Recover profile",
  "account.recovery.user.loading": "Recovering profile...",
  "account.recovery.products.title": "We need to recover your account access",
  "account.recovery.products.message.owner":
    "Your account is missing product access records. Recover them now to load your subscriptions and permissions correctly.",
  "account.recovery.products.message.member": "This account is missing product access records. The owner will need to recover them.",
  "account.recovery.products.action": "Recover access",
  "account.recovery.products.loading": "Recovering access...",
  "account.recovery.action.error": "We couldn't complete the recovery right now. Please try again.",
  "account.recovery.action.permission-denied": "You don't have permission to recover this account.",
  "account.recovery.signout": "Sign out",
};

const profileSelection = {
  "account.profile.selection.title": "Select Profile",
  "account.profile.selection.add": "Add Profile",
  "account.profile.selection.search.placeholder": "Search profiles",
  "account.profile.selection.who": "Who's Training?",
  "account.profile.selection.search.instruction": "Start typing your name to quickly locate your profile",
};

const accountSelection = {
  "account.selection.title": "Select Account",
  "account.selection.description": "Choose an account to access your profiles",
};

const addProfile = {
  "account.profile.add.title": "Add User",
  "account.profile.add.subtitle": "Add a new user to your account",
  "account.profile.add.role.label": "Role",
  "account.profile.add.dob.label": "Date of Birth",
  "account.profile.add.button.cancel": "Cancel",
  "account.profile.add.button.submit": "Add User",
  "account.profile.add.first.label": "First Name",
  "account.profile.add.last.label": "Last Name",
};

const inviteUser = {
  "account.profile.invite.title": "Invite User",
  "account.profile.invite.subtitle": "Invite a user to join your account",
  "account.profile.invite.email.label": "Email",
  "account.profile.invite.email.placeholder": "Enter email address",
  "account.profile.invite.found.label": "User Found",
  "account.profile.invite.role.label": "Role",
  "account.profile.invite.button.cancel": "Cancel",
  "account.profile.invite.button.submit": "Invite User",
  "account.profile.invite.alert.existing": "Existing user found. They will be notified to join your account.",
  "account.profile.invite.alert.new": "New user will be invited to join your account.",
  "account.profile.invite.alert.existing.member": "This user is already a member of your account.",
  "account.profile.invite.alert.caution":
    "Make sure that you have entered the correct email address. If the person you are inviting does not receive an invitation via email, please check the spam folder and that the invited email is spelled correctly. Otherwise, contact Be Your Best support.",
  "account.profile.invite.alert.pending": "This user already has a pending invitation to this account.",
  "account.profile.invite.success.title": "Invitation Sent",
  "account.profile.invite.success.message":
    "An email with invitation instructions has been sent to the user to join your account. If the user does not receive an invitation, please check the spam folder and that the invited email is spelled correctly. Otherwise, contact Be Your Best support.",
};

const pinEntry = {
  "account.pin.locked.title": "Pin Locked",
  "account.pin.locked.message.timed": "You have entered your PIN incorrectly too many times. Your pin access will unlock {{time}}.",
  "account.pin.locked.message.generic": "You have entered your PIN incorrectly too many times. Please try again later.",
  "account.pin.locked.button.signout": "Sign Out",
  "account.pin.entry.welcome": "Welcome back, {{name}}",
  "account.pin.entry.instruction": "Use the key pad or your keyboard to enter your PIN.",
  "account.pin.entry.title": "Enter your pin",
  "account.pin.entry.attempts": "{{count}} attempt{{plural}} remaining",
  "account.pin.entry.button.cancel": "X cancel",
  "account.pin.entry.vr.title": "Enter Your PIN",
  "account.pin.entry.vr.description": "Enter your 4-digit PIN to log in",
  "account.pin.entry.vr.forgot": "Forgot PIN?",
  "account.pin.entry.error.unknown": "An error occurred while switching profiles. Please try again or contact Be Your Best support.",
};

export const account = {
  ...common,
  ...recovery,
  ...profileSelection,
  ...accountSelection,
  ...addProfile,
  ...inviteUser,
  ...pinEntry,
};
